<section fxLayout="row" fxLayout.xs="column"
         fxLayoutGap="20px">

  <bb-number number="4"></bb-number>

  <div fxLayout="column" fxLayoutGap="20px">
    <h2 class="request-txt">{{ 'Current Status'|uppercase }}</h2>
    <bb-employment-state></bb-employment-state>
  </div>
</section>
